export const getLocalesPath = () => {
  const baseUrl = process.env.BASE_URL || '/';
  return `${baseUrl.replace(/\/$/, '')}/locales/`;
};
